<div *ngIf="isMFAAccountEnabled">
    <ui-card [withMargin]="false" class="loadable" [class.loading]="isLoading">
        <h2>{{ 'account.accountSecurity' | translate }}</h2>

        <div class="setting">
            <div class="setting-description">
                <h3>{{ 'account.multi-factor-authentication.title' | translate }}</h3>
                <div>
                    {{
                        'account.multi-factor-authentication.' +
                            (account.isRoleBasedMfaEnabled
                                ? 'youCannotChangeThisSettingWhile'
                                : 'youWillBePromptedToEnroll') | translate
                    }}
                </div>
            </div>
            <mat-slide-toggle
                name="mfaEnabled"
                [disabled]="account.isRoleBasedMfaEnabled"
                [(ngModel)]="isMFAEnabled"
                color="primary"
                (change)="handleToggle()"
            ></mat-slide-toggle>
        </div>
    </ui-card>

    <ui-confirmation-dialog
        #confirmMfaChoice
        header="account.multi-factor-authentication.title"
        primaryButtonLabel="continue"
        primaryButtonType="danger"
        secondaryButtonLabel="cancel"
    >
        <p>{{ 'account.multi-factor-authentication.youAreAboutToEnrollInMfa' | translate }}</p>
        <p>{{ 'account.multi-factor-authentication.pleaseSecurelyStoreTheRecoveryCode' | translate }}</p>
        <ul>
            <li>{{ 'account.multi-factor-authentication.oneTimePassword' | translate }}</li>
            <li>{{ 'account.multi-factor-authentication.email' | translate }}</li>
            <li>{{ 'account.multi-factor-authentication.textSms' | translate }}</li>
        </ul>
        <p [innerHTML]="'account.multi-factor-authentication.toLearnMoreVisitOurHelpCentre' | translate"></p>
    </ui-confirmation-dialog>
</div>
